module.exports = __webpack_public_path__ + "img/V16.14cb050a.png";